import { useEffect, useState } from 'react'
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import Loader from '../../../components/ui/Loader/Loader';
import Status from '../../../components/ui/Status';


export default function AssetSCSDetail({assetScsId, assetSCSDetailData}) {

    const assetScsUrl           =   BACKOFFICE_BASE_URL + '/scs';
    const access_token          =   useSelector(state => state.auth.access_token);

    const [loading, setLoading]         =   useState(false);
    const [detailData, setDetailData]   =   useState(null);


    useEffect(() => {
        if(assetScsId) {
            detail()
        }
    }, [assetScsId])

    const detail    = () => {
        setLoading(true);
        HttpAPICall.withAthorization('GET', assetScsUrl + '/detail/' + assetScsId, access_token, {}, {}, (resp) => {
            setDetailData(resp.data);
            assetSCSDetailData(resp.data);
        }).then(() => setLoading(false));
    }   


  return (
    <section className="item_view_container bg-white">
        {
            loading 
            ? <Loader/>
            :
            <>
            <ul className="nav nav-tabs" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                    <button className="nav-link active" id="details-tab" data-bs-toggle="tab" data-bs-target="#details"
                        type="button" role="tab" aria-controls="details" aria-selected="true">Details
                    </button>
                </li>
            </ul>
            <div className="tab-content" id="myTabContent">
                <div className="tab-pane  show active" id="details" role="tabpanel" aria-labelledby="details-tab">
                    <div className="tab_content_header">
                        <div className="tab_content_wrapper"> <span className="content_heading">Details</span></div>
                        <table className="table table-hover table-bordered  table-responsive bg-white my-2 ">
                            <tbody className='resource_table'>
                                <tr>
                                    <td style={{ width: "25%" }}>SCS Name</td>
                                    <th>{detailData?.name}</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "25%" }}>Asset Type Name</td>
                                    <th>{detailData?.asset_type?.asset_type_name}</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "25%" }}>Section</td>
                                    <th>{detailData?.section?.component}</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "25%" }}>Sub Section</td>
                                    <th>{detailData?.sub_section?.subcomponent}</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "25%" }}>Status</td>
                                    <th><Status color={detailData?.status.status_color_code}>{detailData?.status.status_text}</Status></th>
                                </tr>
                                <tr>
                                    <td style={{ width: "25%" }}>Description</td>
                                    <th>{detailData?.description}</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "25%" }}>Creation Date</td>
                                    <th>{detailData?.created_at}</th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            </>
        }
    </section>
  )
}
